import { Injectable } from "@angular/core";

declare var PhotoSwipe: any;
declare var PhotoSwipeUI_Default: any;

export enum media_type {
  image,
  embedded
}
export interface PhotoZoomData {
  src?: string;
  url?: string;
  caption: string;
  type: media_type;
  width: number;
  height: number;
}
@Injectable()
export class PhotoZoomService {

  constructor() {
  }

  zoomFn(photoList: PhotoZoomData[], index: number = 0, width?: number , height?: number ) {
    let pswpElement = document.querySelectorAll('.pswp')[0];
    let items: any = [];
    let objData: any;

    photoList.forEach(obj => {
      if (obj.type == media_type.embedded) {
        objData = {
          width : obj.width,
          height : obj.height,
          html: `
          <div class="wrapper">
            <div class="video-wrapper">
              <iframe class="pswp__video" width="${obj.width}" height="${obj.height}" src="${obj.url}" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>`
        }
      }
      else if (obj.type == media_type.image) {
        objData = {
          src: obj.url || obj.src,
          w: obj.width,
          h: obj.height
        }
      }
      objData.title = obj.caption
      items.push(objData);
    });

    // define options (if needed)
    var options = {
      // optionName: 'option value'
      index: index // start at first slide
    };

    // Initializes and opens PhotoSwipe
    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();

    gallery.listen('beforeChange', function () {
      var currItem = $(gallery.currItem.container);
      $('.pswp__video').removeClass('active');
      var currItemIframe = currItem.find('.pswp__video').addClass('active');
      $('.pswp__video').each(function () {
        if (!$(this).hasClass('active')) {
          $(this).attr('src', $(this).attr('src'));
        }
      });
    });

    gallery.listen('close', function () {
      $('.pswp__video').each(function () {
        $(this).attr('src', $(this).attr('src'));
      });
    });
  }
}